import { odata } from '@bingads-webui/http-util';
import _ from 'underscore';

import { PERFORMANCE_INSIGHTS_ISSUE } from '../constants/consts';

export const fetchPerformanceInsightsData = ({ serverContext }) => { // , entity }) => {
  // TODO: update tp real account id(ParentEntityId) and campaign id(CheckpointEntityId)
  // const campaignId = entity.Id;
  // const accountId = serverContext.CurrentAccount.Id;
  const odataPath = 'AdInsight/V2';
  const oDataConfig = {
    odataToken: serverContext.Token,
    odataPath: `${serverContext.ServicesEndpoints.AdInsightAPI}${odataPath}`,
  };
  const oDataOptions = {
    contentType: 'application/json',
    path: oDataConfig.odataPath,
    oDataToken: oDataConfig.odataToken,
  };
  const baseURL = `${oDataConfig.odataPath}/CheckPointEntities/Insight.GetUnifiedInsightsData`;
  const payload = {
    // TODO: update tp real account id(ParentEntityId) and campaign id(CheckpointEntityId)
    /*
    CheckpointEntityCollection: [
      {
        CheckpointEntityId: campaignId,
        CheckpointEntityLevel: 'Campaign',
        ParentEntityId: accountId,
      },
    ],
    */
    CheckpointEntityCollection: [
      {
        CheckpointEntityId: 20358,
        CheckpointEntityLevel: 'Campaign',
        ParentEntityId: 79674707,
      },
    ],
    CheckpointIdentifiers: [
      {
        CheckpointKey: PERFORMANCE_INSIGHTS_ISSUE.BID,
        CheckpointDataTypes: ['HealthCheck_SummaryView'],
      },
      {
        CheckpointKey: PERFORMANCE_INSIGHTS_ISSUE.BUDGET,
        CheckpointDataTypes: ['HealthCheck_SummaryView'],
      },
    ],
  };
  const options = _.extend(
    {},
    oDataOptions,
    {
      url: baseURL,
      data: payload,
    }
  );
  return odata.post(options);
};
